import React from 'react';
import { Copy, Help, SystemText } from '@salesperformanceint/e4shared';

const FeedbackHelp = () => (
    <Help id="manager-feedback">
        <Copy value={SystemText('Objective/Feedback/Help')} />
    </Help>
);

export default FeedbackHelp;
